import { Input } from "../../../../components/ui/common/input";
import { Label } from "../../../../components/ui/common/label";
import { DELETE_MAPPING_COPY } from "../constants/deleteMapping.constants";
import { DeleteConfirmPhraseInputProps } from "../types/deleteMapping.types";

/** The typed-confirmation gate. Presentational; the match is evaluated by useDeleteMappingDialog. */
const DeleteConfirmPhraseInput = ({
  value,
  onChange,
  requiredPhrase,
  disabled
}: DeleteConfirmPhraseInputProps) => (
  <div className="tw-space-y-2">
    <Label htmlFor="delete-confirm-phrase">{DELETE_MAPPING_COPY.confirmLabel(requiredPhrase)}</Label>
    <Input
      id="delete-confirm-phrase"
      value={value}
      onChange={event => onChange(event.target.value)}
      placeholder={DELETE_MAPPING_COPY.confirmPlaceholder(requiredPhrase)}
      autoComplete="off"
      disabled={disabled}
      // The shared Input has no focus styling of its own (see common/input.tsx), so its ring
      // color today is just the browser's default -- pin it to the app's primary green instead,
      // matching the ring/border-ring pattern already used by select.tsx.
      className="focus-visible:tw-border-ring focus-visible:tw-ring-2 focus-visible:tw-ring-ring/50"
    />
    <p className="tw-m-0 tw-text-xs tw-text-muted-foreground">{DELETE_MAPPING_COPY.confirmHint}</p>
  </div>
);

export default DeleteConfirmPhraseInput;
